export default "__VITE_ASSET__a1d8d06f__"